import React, { useEffect, useState } from 'react';
import isAuthenticated from '../actions/isAuthenticated';
import auth from '../services/auth';
import Loading from './Loading';
import { ErrorMessage } from './ErrorMessage';
import Layout from './Layout';

interface ScopesRequiredProps {
    allowedScopes: string[];
    children: React.ReactNode;
}

export const ScopesRequired = ({ allowedScopes, children }: ScopesRequiredProps) => {
    const [isLoading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        (async () => {
            try {
                await isAuthenticated();
                const res = await auth.getUserInfo();
                const hasScope = allowedScopes.some(s => res.data?.scopes?.includes(s));
                if (!hasScope) {
                    throw new Error('INSUFFICIENT_SCOPES');
                }
            } catch (e) {
                setError(e.message);
            } finally {
                setLoading(false);
            }
        })();
    }, []);

    if (isLoading) {
        return <Loading />;
    }
    if (error) {
        return (
            <Layout>
                <ErrorMessage isDirty={true} i18nKey={error} />
            </Layout>
        );
    }

    return <>{children}</>;
};
